import { render, staticRenderFns } from "./PickPoint.vue?vue&type=template&id=020199c6&"
import script from "./PickPoint.vue?vue&type=script&lang=js&"
export * from "./PickPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports